import React from 'react';
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { validateTokenAction } from "../../auth";
import { useHistory } from "react-router-dom";
import './LoginAction.scss';
import {SET_CAMPAIGN} from "../../../types/types";


export const setCampaign = (data) => {
    return {
        type: SET_CAMPAIGN,
        payload: data
    }
}

const LoginAction = () => {
    const dispatch = useDispatch();
    const history = useHistory();


    useEffect(() => {

        dispatch(validateTokenAction())
            .then(() => {
                history.push("/");
            })
            .catch(() => {
                history.push("/login");
            });
        
    },[dispatch]);

    return <p className='authenticated'>Autenticando...</p>

};

export default LoginAction;